import styled from 'styled-components'
import { theme } from '@/client/components'
const { color, space, breakpoint } = theme

export const Featured = styled.div<{ $imageUrl?: string; $background_color?: string }>`
  padding: ${space.xl};
  background: ${(p) =>
    p.$imageUrl ? `url(${p.$imageUrl})` : p.$background_color ? p.$background_color : color.grayscale.lightDark};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: unset;
  height: 500px;

  @media (min-width: ${breakpoint.lg}) {
    background-position: center;
    height: 700px;
    padding: ${space.lg} 0 ${space.xl4};
  }
`

export const MainFeatured = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  height: 100%;
  padding: 0 0 ${space.xl};

  @media (min-width: ${breakpoint.lg}) {
    flex-direction: row;
    padding: ${space.xl} 0 ${space.xl2} 0;
  }
`

export const FullFeatured = styled.div`
  width: 100%;

  // .header_text,
  // .header_description,
  // .benefits_list,
  // .list_text {
  //   color: #000;
  // }

  @media (min-width: ${breakpoint.lg}) {
    order: 1;
    width: 60%;
  }
`

export const PostMeta = styled.div`
  padding: 0.5rem 0;
`
export const PostTagWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`
